import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

const TypingText = ({ text }) => {
  const textRef = useRef(null);

  useEffect(() => {
    const chars = text.split("");
    textRef.current.innerHTML = chars
      .map((char) => `<span>${char}</span>`)
      .join("");

    gsap.fromTo(
      textRef.current.children,
      { opacity: 0 },
      { opacity: 1, duration: 0.05, stagger: 0.05 }
    );
  }, [text]);

  return <span ref={textRef}></span>;
};

export default TypingText;
